/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['locationWebsites', 'items', id], null);